import EmmitedDocumentReport from "./EmmitedDocumentReport";

export default EmmitedDocumentReport;
